// extracted by mini-css-extract-plugin
export default {"container":"xZ-z","heading":"yZ-z","links":"zZ-z","copy":"AZ-z","subCopy":"BZ-z","linksLeft":"CZ-z","linksCenter":"DZ-z","linksRight":"EZ-z","link":"FZ-z","onlyLink":"GZ-z"};